import React from 'react';

import AccountsCampaignsTrendChart from './AccountsCampaignsTrendChart';
import Bottom10EngagingAccounts from './Bottom10EngagingAccounts';
import CampaignPerformanceTables from './CampaignPerformanceTables';
import CampaignPerformanceTrendChart from './CampaignPerformanceTrendChart';
import ContactLists from './ContactLists';
import EngagementTrendChart from './EngagementTrendChart';
import HighlyLikelyAccountsTable from './HighlyLikelyAccountsTable';
import SalesPersonaEngagementChart from './SalesPersonaEngagementChart';
import TopEngagedPagesKeywordsCharts from './TopEngagedPagesKeywordsCharts';
import TopVisitedWebPages from './TopVisitedPages';

interface SectionProps {
  data: SectionDataType;
  key: string;
  title?: string;
}

export type SectionDataType = unknown; // Placeholder type for section data. Update SectionDataType when the schema is defined.

export default {
  AccountsCampaignsTrendChart,
  Bottom10EngagingAccounts,
  CampaignPerformanceTables,
  CampaignPerformanceTrendChart,
  ContactLists,
  EngagementTrendChart,
  HighlyLikelyAccountsTable,
  SalesPersonaEngagementChart,
  TopEngagedPagesKeywordsCharts,
  TopVisitedWebPages,
} as Record<string, (props: SectionProps) => React.ReactElement>;
